import { render, staticRenderFns } from "./BurgerMenuIcon.vue?vue&type=template&id=ddf445d8&"
import script from "./BurgerMenuIcon.vue?vue&type=script&lang=js&"
export * from "./BurgerMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenuIcon.vue?vue&type=style&index=0&id=ddf445d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports